import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showBannerNotification: true,
};

const notificationSlice = createSlice({
  name: "notification_slice",
  initialState,
  reducers: {
    setShowBannerNotification: (state, action) => {
      state.showBannerNotification = action.payload;
    },
    resetNotifications: () => {
      return initialState;
    },
  },
});

export const { setShowBannerNotification, resetNotifications } =
  notificationSlice.actions;

export default notificationSlice.reducer;
